import { put, takeEvery} from 'redux-saga/effects';
import { COLLECTION_STATISTICS } from './constants';
import { requestStatisticsShare } from './api';
import { collectionStatisticsShareSuccess } from './actions';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{type, sharing}>>}
 */
function* collectionStatisticsShare(actionObj) {
    const share = yield requestStatisticsShare(actionObj.hatchId, actionObj.text);
    if(share) {
        yield put(collectionStatisticsShareSuccess(share));
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchShare() {
    yield takeEvery(COLLECTION_STATISTICS, collectionStatisticsShare);
}

export default watchShare;